import * as yup from 'yup';

export const blogSchema = yup.object().shape({
  title: yup.string().required(),
  remarks: yup.string().required(),
  categoryId: yup.array().of(yup.string()),
  tagId: yup.array().of(yup.string()),
  quillText: yup.string().min(1)
})


// WEBPACK FOOTER //
// ./src/views/Blog/Post/blogSchema.js